let client = {};
client.device = getDevice();
client.OS = getOS();
client.AR = getArSupport();

function getDevice() {
    return /Android|iPhone|iPad/i.test(navigator.userAgent)
        ? 'mobile'
        : 'pc';
}

function getOS() {
    if (/iPhone|iPad/i.test(navigator.userAgent)) {
        return 'ios';
    }

    if (/Android/i.test(navigator.userAgent)) {
        return 'android';
    }

    if (/Windows/i.test(navigator.userAgent)) {
        return 'windows';
    }

    if (/Mac OS/i.test(navigator.userAgent)) {
        return 'macos';
    }

    if (/(Linux|X11)/i.test(navigator.userAgent)) {
        return 'linux';
    }

    return 'unknown';
}

function getArSupport() {
    if (client.OS === 'ios') {
        return true;
    }

    if (client.OS === 'android') {
        return true;
    }

    return false;
}

export default client;